const app = require('loginApp');
const route = require('shared/router/routeLogin');

const controller = require('app/login/loginController');

const appRoutes = {
    '': 'showLogin',
    'login': 'showLogin',
    '*notFound': 'routeNotFound'
};

const api = {
    'routeNotFound': function (notFound) {
        window.location.href = '/login.html';
    },
    'showLogin': function () {
        controller.show(app.getView().getRegion('mainRegion'));
    }
};

route(appRoutes, api);